// this one we actually use and need
window.atmSearch = window.atmSearch || {};

// TODO centralize global stuff here

export {};
